<template>
  <a-layout id="components-layout-demo-top-side-2" style="overflow-y: hidden">
    <a-layout-header
      class="header"
      style="background: #00479c; border: 1px solid #000000; padding-left: 10px"
    >
      <div>
        <div style="float: right; width: 220px; margin-right: 20px">
          <div style="float: left; width: 140px">
            <!-- <div style="float:left;margin-right:10px;">
              <img :src="photo" style="width:40px;border-radius: 50px;">
            </div> -->
            <div>
              <a-dropdown>
                <a
                  style="color: #ffffff; float: right; margin-right: 20px"
                  class="ant-dropdown-link"
                >
                  {{ userName }}
                  <a-icon type="down " />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a-button
                      href="javascript:;"
                      @click="showModal"
                      style="display: block; margin: 0; border: none"
                      >用户信息</a-button
                    >
                    <a-modal
                      title="用户信息"
                      :visible="visible"
                      okText="保存"
                      @ok="handleOk"
                      :confirmLoading="confirmLoading"
                      @cancel="handleCancel"
                      centered
                    >
                      <p>
                        <span style="margin-left: 35px">用户帐号：</span>
                        <a-input
                          style="width: 200px"
                          v-model="person.userName"
                          :read-only="true"
                        />
                      </p>
                      <p>
                        <span style="margin-left: 35px">用户姓名：</span>
                        <a-input
                          placeholder="请输入"
                          style="width: 200px"
                          v-model="person.name"
                        />
                      </p>
                      <p>
                        <span style="margin-left: 35px">用户角色：</span>
                        <a-input
                          style="width: 200px"
                          v-model="person.roleName"
                          :read-only="true"
                        />
                      </p>
                      <p>
                        <span style="margin-left: 35px">默认编辑：</span>
                        <a-checkbox :checked="true" :disabled="true"
                          >是</a-checkbox
                        >
                      </p>
                    </a-modal>
                  </a-menu-item>

                  <a-menu-item>
                    <a-button
                      href="javascript:;"
                      @click="showBox"
                      style="display: block; margin: 0; border: none"
                      >修改密码</a-button
                    >
                  </a-menu-item>
                  <a-menu-item>
                    <SysVersion />
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </div>

          <div style="float: right; width: 80px">
            <div style="float: left">
              <a-badge :count="informCount" @click="showInform">
                <img
                  src="..\..\assets\notice.png"
                  style="width: 20px; height: 20px; cursor: pointer"
                />
                <a href="#" class="head-example"></a>
              </a-badge>
            </div>
            <div style="float: right">
              <a-badge style="margin-left: 20px">
                <a @click="exit" style="color: #ffffff">退出</a>
              </a-badge>
            </div>
          </div>
        </div>

        <a-modal
          title="修改密码"
          :visible="visibles"
          centered
          :maskClosable="false"
          :destroyOnClose="true"
          :closable="!changePwd"
        >
        <template slot="footer">
          <a-button key="back" @click="handleCancels" v-if="!changePwd">
            取消
          </a-button>
          <a-button key="submit" type="primary" :loading="confirmLoadings" @click="handleOks">
            保存
          </a-button>
        </template>
          <!-- <img
            :src="newPhoto"
            style="
              width: 90px;
              height: 90px;
              margin: 0 40%;
              border-radius: 50px;
            "
          />
          <p style="color: #1abc9c; text-align: center">
            <a-upload
              name="file"
              :fileList="fileList"
              :action="uploadAddress"
              :headers="headers"
              @change="uploadFile"
              :remove="fileRemove"
              :data="data"
              accept=".png, .jpg"
            >
              <a-button>
                <a-icon type="upload" />选择图片
              </a-button>
            </a-upload>
          </p> -->
          <p style="text-align: center; margin-top: 30px">
            <span style="margin-left: 21px">用户名：</span>
            <a-input
              placeholder="请输入"
              style="width: 200px"
              v-model="confirmZH"
              read-only
            />
          </p>
          <p style="text-align: center">
            <span style="color: red; margin-left: 15px">*</span>
            <span>旧密码：</span>
            <a-input
              placeholder="请输入"
              style="width: 200px"
              v-model="oldPwd"
            />
          </p>
          <p style="text-align: center">
            <span style="color: red; margin-left: 15px">*</span>
            <span>新密码：</span>
            <a-input
              placeholder="请输入"
              style="width: 200px"
              v-model="newPwd"
            />
            <span class="note" style="display: block;"> 密码8至16位，包含大小写字母、数字和特殊字符 </span>
          </p>
          <p style="text-align: center">
            <span style="color: red">*</span>
            <span>确认密码：</span>
            <a-input
              placeholder="请输入"
              style="width: 200px"
              v-model="confirmNew"
            />
          </p>
        </a-modal>

        <a-modal
          title="消息"
          :visible="informVisible"
          width="800px"
          :dialog-style="{ top: '30px' }"
          @cancel="informCancel"
          :destroyOnClose="true"
          :footer="null"
          :maskClosable="false"
        >
          <a-list
            item-layout="horizontal"
            :data-source="informData"
            style="padding-left: 12px; padding-right: 12px"
          >
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta>
                <a
                  slot="title"
                  href="javascript:;"
                  @click="dealInform(item.type, item.informCode)"
                  >{{ `${index + 1}、${item.content}` }}</a
                >
                <span
                  style="display: inline-block; text-align: right; width: 100%"
                  slot="description"
                  >{{ item.creatTime }}</span
                >
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-modal>
      </div>
      <div
        style="
          height: 64px;
          width: 190px;
          line-height: 64px;
          float: left;
          text-align: center;
        "
      >
        <!-- <div class="logo" style="width: 50px; height: 50px; float: left">
          <img :src="logo" style="width: 40px; height: 40px" />
        </div> -->
        <span
          style="
            color: #ffffff;
            font-size: 18px;
            font-family: '黑体 Bold', '黑体 Regular', '黑体';
          "
          >{{ editSystemName }}</span
        >
      </div>
      <a-menu
        style="background-color: #00479c; color: #ffffff"
        mode="horizontal"
        :defaultSelectedKeys="defaultHeaderSelectedKey"
        :style="{ lineHeight: '64px' }"
      >
        <a-menu-item
          :key="first.menuCode"
          v-for="first in menus"
          @click="firstClick(first.menuCode)"
          >{{ first.menuName }}</a-menu-item
        >
      </a-menu>
    </a-layout-header>

    <a-layout>
      <a-layout-sider width="200" style="background: #eaedf1">
        <a-menu
          style="background: #eaedf1"
          mode="inline"
          @click="handleClick"
          :defaultSelectedKeys="defaultSiderSelectedKey"
          :defaultOpenKeys="defaultOpenKey"
          :style="{ height: '100%', borderRight: 0 }"
        >
          <template v-for="second in secondMenus">
            <a-menu-item :key="second.menuCode" v-if="second.child == null">
              <router-link :to="second.url">
                <span>{{ second.menuName }}</span>
              </router-link>
            </a-menu-item>
            <a-sub-menu :key="second.menuCode" v-if="second.child != null">
              <span slot="title">
                <span>{{ second.menuName }}</span>
              </span>
              <a-menu-item :key="third.menuCode" v-for="third in second.child">
                <router-link :to="third.url">
                  <span>{{ third.menuName }}</span>
                </router-link>
              </a-menu-item>
            </a-sub-menu>
          </template>
        </a-menu>
      </a-layout-sider>

      <a-layout>
        <a-breadcrumb style="height: 32px; line-height: 32px; padding: 0 12px">
          <a-breadcrumb-item>{{ currentMenu }}</a-breadcrumb-item>
        </a-breadcrumb>
        <a-layout-content
          :style="{
            padding: '8px',
            height: 'calc(100vh - 96px)',
          }"
        >
          <router-view></router-view>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>
<script>
import qs from "qs";
import SysVersion from "../commomon/SysVersion.vue";
export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      menus: [],
      secondMenus: [],
      currentMenu: "",
      defaultHeaderSelectedKey: [],
      defaultSiderSelectedKey: [],
      defaultOpenKey: [],
      firstMenuName: "",
      userName: "",
      informCount: 0,
      informVisible: false,
      informData: [],
      value: 1,
      visible: false,
      visibles: false,
      confirmLoading: false,
      confirmLoadings: false,
      roles: {},
      person: {},
      photo: "",
      newPhoto: "",
      date: null,
      zhanghao: "",
      confirmZH: "",
      oldPwd: "",
      newPwd: "",
      confirmNew: "",
      serviceAddress: this.$config.serviceAddress,
      uploadAddress: this.$config.serviceAddress + "/file/uploadHeadPortrait",
      headers: {
        authorization: "authorization-text",
      },
      data: {
        fileType: "headPortrait",
      },
      fileList: [],
      isRouterAlive: true,
      editSystemName: "",
      logo: "",
      changePwd: false,
    };
  },
  components: {
    SysVersion: SysVersion,
  },
  created() {
    document.onkeydown = function () {};

    this.getCurrent();
    this.queryLogo();

    var secondMenus = JSON.parse(sessionStorage.getItem("secondMenus"));
    if (secondMenus != "") {
      this.secondMenus = secondMenus;
    }
    var defaultHeaderSelectedKey = sessionStorage.getItem(
      "defaultHeaderSelectedKey"
    );
    if (defaultHeaderSelectedKey != null) {
      this.defaultHeaderSelectedKey.splice(0, 1, defaultHeaderSelectedKey);
    }
    var defaultSiderSelectedKey = sessionStorage.getItem(
      "defaultSiderSelectedKey"
    );
    if (defaultSiderSelectedKey != null) {
      this.defaultSiderSelectedKey.splice(0, 1, defaultSiderSelectedKey);
    }
    var defaultOpenKey = sessionStorage.getItem("defaultOpenKey");
    if (defaultOpenKey != null) {
      this.defaultOpenKey.splice(0, 1, defaultOpenKey);
    }
    var currentMenu = sessionStorage.getItem("currentMenu");
    if (currentMenu != null) {
      this.currentMenu = currentMenu;
    }
  },
  mounted() {
    this.changePwd = sessionStorage.getItem("needChangePwd") == "true";
    if (this.changePwd) {
      this.$message.warning("检测到您密码强度低，请修改密码后才能登录系统");
      this.showBox();
    }
  },
  methods: {
    firstClick(menuCode) {
      this.defaultHeaderSelectedKey.splice(0, 1, menuCode);
      sessionStorage.setItem(
        "defaultHeaderSelectedKey",
        this.defaultHeaderSelectedKey[0]
      );
      for (var i = 0; i < this.menus.length; i++) {
        if (menuCode == this.menus[i].menuCode) {
          this.firstMenuName = this.menus[i].menuName;
          this.secondMenus = this.menus[i].child;
          sessionStorage.setItem(
            "secondMenus",
            JSON.stringify(this.secondMenus)
          );
        }
      }
    },
    queryLogo() {
      this.axios
        .get("/basicInfo/queryBasicInfo", {
          params: {
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.editSystemName = res.data.data.editSystemName;
            this.logo = this.serviceAddress + res.data.data.logoPath;
          } else {
            this.utils.messageInfo(this, "error", "查询系统基本信息失败！");
          }
        });
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    getCurrent() {
      this.axios
        .get("/systemUser/getCurrent", {
          params: {
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            var systemUser = res.data.data.systemUser;
            this.userName = systemUser.name;
            this.menus = res.data.data.menus;
            this.informCount = res.data.data.informCount;
            if (sessionStorage.getItem("defaultHeaderSelectedKey") == null) {
              this.defaultHeaderSelectedKey.push(this.menus[0].menuCode);
              this.firstMenuName = this.menus[0].menuName;
              this.secondMenus = this.menus[0].child;
              this.currentMenu = this.firstMenuName + ">>";
              if (this.secondMenus[0].child) {
                this.defaultOpenKey.push(this.secondMenus[0].menuCode);
                this.currentMenu +=
                  this.secondMenus[0].menuName +
                  ">>" +
                  this.secondMenus[0].child[0].menuName;
                if (this.defaultSiderSelectedKey.length == 0) {
                  this.defaultSiderSelectedKey.push(
                    this.secondMenus[0].child[0].menuCode
                  );
                }
              } else {
                if (this.defaultSiderSelectedKey.length == 0) {
                  this.defaultSiderSelectedKey.push(
                    this.secondMenus[0].menuCode
                  );
                }
                this.currentMenu += this.secondMenus[0].menuCode;
              }
            }
          } else {
            this.exit();
          }
        });
    },
    uploadFile(info) {
      this.fileList = [];
      if (info.fileList.length == 2) {
        info.fileList.splice(0, 1);
      }
      let fileList = [...info.fileList];
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
      if (info.file.status !== "uploading") {
        this.fileList = info.fileList;
        if (this.fileList[0].response.code == "OK") {
          this.newPhoto =
            this.serviceAddress + this.fileList[0].response.data.filePath;
        }
      }
      if (info.file.status === "done") {
        this.utils.messageInfo(this, "success", "上传成功");
      } else if (info.file.status === "error") {
        this.utils.messageInfo(this, "error", "上传失败");
      }
    },
    fileRemove() {
      this.fileList = [];
    },
    dealInform(type, informCode) {
      this.informVisible = false;
      this.$bus.emit("changeShow", false);
      if (type == 21) {
        // 责编跳转未处理稿件
        this.informUpdate(
          type,
          informCode,
          "/myManuscript",
          "12",
          "1202",
          "120201"
        );
      } else if (type == 22) {
        //责编跳转处理中稿件
        this.informUpdate(type, informCode, "/notBack", "12", "1202", "120202");
      } else if (type == 23) {
        //责编跳转审校完成稿件
        this.informUpdate(type, informCode, "/back", "12", "1202", "120203");
      } else if (type == 31 || type == 32 || type == 41 || type == 42) {
        //主编跳转跳转待处理稿件
        this.informUpdate(
          type,
          informCode,
          "/auditing",
          "13",
          "1301",
          "130101"
        );
      }
    },
    //设置消息状态为已读
    informUpdate(
      type,
      informCode,
      router,
      defaultHeaderSelectedKey,
      defaultOpenKey,
      defaultSiderSelectedKey
    ) {
      this.axios
        .post("/inform/updateInform", {
          informCode: informCode,
          userCode: sessionStorage.getItem("userCode"),
          status: 1,
          type: type,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.$router.push(router);
            this.defaultHeaderSelectedKey.splice(
              0,
              1,
              defaultHeaderSelectedKey
            );
            this.defaultOpenKey.splice(0, 1, defaultOpenKey);
            this.defaultSiderSelectedKey.splice(0, 1, defaultSiderSelectedKey);

            this.queryInformCount();
          }
        });
    },
    queryInformCount() {
      this.axios
        .get("/inform/queryInformCount", {
          params: {
            userCode: sessionStorage.getItem("userCode"),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          this.informCount = res.data;
        });
    },
    showInform() {
      this.informVisible = true;
      this.$bus.emit("changeShow", true);
      this.axios
        .get("/inform/queryInform", {
          params: {
            userCode: sessionStorage.getItem("userCode"),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          this.informData = res.data;
        });
    },
    informCancel() {
      this.informVisible = false;
      this.$bus.emit("changeShow", false);
    },
    handleClick(e) {
      // this.getCurrent();

      // for (var n = 0; n < this.menus.length; n++) {
      //   if (this.defaultHeaderSelectedKey[0] == this.menus[n].menuCode) {
      //     this.firstMenuName = this.menus[n].menuName;
      //     this.secondMenus = this.menus[n].child;
      //     sessionStorage.setItem(
      //       'secondMenus',
      //       JSON.stringify(this.secondMenus)
      //     );
      //   }
      // }

      var menuPath = e.keyPath;
      if (menuPath.length == 2) {
        this.defaultSiderSelectedKey.splice(0, 1, menuPath[0]);
        this.defaultOpenKey.splice(0, 1, menuPath[1]);
        sessionStorage.setItem(
          "defaultSiderSelectedKey",
          this.defaultSiderSelectedKey[0]
        );
        sessionStorage.setItem("defaultOpenKey", this.defaultOpenKey[0]);
        for (var i = 0; i < this.secondMenus.length; i++) {
          if (menuPath[1] == this.secondMenus[i].menuCode) {
            for (var j = 0; j < this.secondMenus[i].child.length; j++) {
              if (menuPath[0] == this.secondMenus[i].child[j].menuCode) {
                this.currentMenu =
                  this.firstMenuName +
                  ">>" +
                  this.secondMenus[i].menuName +
                  ">>" +
                  this.secondMenus[i].child[j].menuName;
                sessionStorage.setItem("currentMenu", this.currentMenu);
                break;
              }
            }
            break;
          }
        }
      } else if (menuPath.length == 1) {
        this.defaultSiderSelectedKey.splice(0, 1, menuPath[0]);
        sessionStorage.setItem(
          "defaultSiderSelectedKey",
          this.defaultSiderSelectedKey[0]
        );
        for (var ii = 0; ii < this.secondMenus.length; ii++) {
          if (menuPath[0] == this.secondMenus[ii].menuCode) {
            this.currentMenu =
              this.firstMenuName + ">>" + this.secondMenus[ii].menuName;
            sessionStorage.setItem("currentMenu", this.currentMenu);
            break;
          }
        }
      }
      //刷新页面
      // this.reload();
    },
    exit() {
      this.$router.push("/editLogin");
      this.axios.get("/systemUser/logout");
    },
    showModal() {
      this.axios.get("/systemUser/queryAllRole").then((res) => {
        this.roles = res.data;
      });
      this.axios
        .get("/systemUser/queryByUserCode", {
          params: {
            userCode: sessionStorage.getItem("userCode"),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          this.person = res.data;
          this.visible = true;
        });
    },
    handleOk() {
      this.axios
        .post("/systemUser/updatePerson", {
          userCode: sessionStorage.getItem("userCode"),
          name: this.person.name,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "编辑成功");
            this.visible = false;
            this.userName = this.person.name;
          } else {
            this.utils.messageInfo(this, "error", res.data.data);
          }
        });
      // this.confirmLoading = true;
      // setTimeout(() => {
      //   this.visible = false;
      //   this.confirmLoading = false;
      // }, 2000);
    },
    handleCancel() {
      this.visible = false;
    },
    showBox() {
      this.confirmZH = "";
      this.oldPwd = "";
      this.newPwd = "";
      this.confirmNew = "";
      this.newPhoto = this.photo;

      this.axios
        .get("/systemUser/queryByUserCode", {
          params: {
            userCode: sessionStorage.getItem("userCode"),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          this.confirmZH = res.data.userName;
          this.visibles = true;
        });
    },
    handleOks() {
      if (this.oldPwd == "") {
        this.utils.messageInfo(this, "error", "请输入旧密码！");
        return;
      } else if (this.newPwd == "") {
        this.utils.messageInfo(this, "error", "请输入新密码！");
        return;
      } 
      if (!this.utils.checkPwd(this.newPwd)) {
        this.utils.messageInfo(this, "error", "密码必须是8至16位，包含大小写字母、数字和特殊字符");
        return;
      }
      if (this.newPwd != this.confirmNew) {
        this.utils.messageInfo(this, "error", "新密码和确认密码不一致！");
        return;
      }

      var imgPath = "";
      if (this.fileList.length > 0) {
        if (this.fileList[0].response.code == "OK") {
          imgPath = this.fileList[0].response.data.filePath;
        }
      }

      this.axios
        .post("/systemUser/updatePwd", {
          userCode: sessionStorage.getItem("userCode"),
          oldPwd: this.oldPwd,
          newPwd: this.newPwd,
          imgPath: imgPath,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "修改成功,请重新登录");
            this.exit();
          } else {
            this.utils.messageInfo(this, "error", res.data.data);
          }
        });
      // this.confirmLoadings = true;
      // setTimeout(() => {
      //   this.visibles = false;
      //   this.confirmLoadings = false;
      // }, 2000);
    },
    handleCancels() {
      this.visibles = false;
    },
    handleChange() {},
  },
};
</script>

<style>
#components-layout-demo-top-side-2 .logo img {
  margin-bottom: 8px;
}
#root {
  width: 100%;
  font-size: 15px;
}
</style>
